import {Component, EventEmitter, Input, Output, ViewChild, ElementRef, NgZone, ApplicationRef} from '@angular/core';
import {Camera, CameraOptions} from '@ionic-native/camera';

import {File as NativeFile, FileEntry} from '@ionic-native/file';
import {ActionSheetController, AlertController, Platform} from 'ionic-angular';
import {Base64Parser} from '../../shared/services/base64Parser.service';
import { Base64FileInterface } from '../../shared/models/base64File/base64File.interface';
import { Chooser } from '@ionic-native/chooser';

@Component({
  selector: 'core-file-selector',
  templateUrl: './file-selector.component.html'
})
export class FileSelectorComponent {
  @Input() public fileName: string;
  @Input() public url: string;
  @Input() public isEditable = null;
  @Input() public buttonLabel = 'Ajouter une pièce jointe';


  @Output() public onAdded = new EventEmitter<{base64File: Base64FileInterface, fileName: string, fileType: string}>();
  @Output() public onDeleted = new EventEmitter<any>();
  @Output() public onClick = new EventEmitter<any>();

  @ViewChild('inputFile') inputFile: ElementRef;
  private extensionsAutorisees = ['jpg', 'png', 'pdf', 'jpeg'];
  constructor(
    private camera: Camera,
    private file: NativeFile,
    private actionSheetCtrl: ActionSheetController,
    private alertCtrl: AlertController,
    private base64Parser: Base64Parser,
    private platform: Platform,
    private chooser: Chooser,
    private appRef: ApplicationRef
  ) {
  }

  public addClick(): void {
    if (this.platform.is('mobileweb') || this.platform.is('core')) {
      this.inputFile.nativeElement.click();
    } else {
      this.presentActionSheet();
    }

  }

  public emitAdded(base64File: Base64FileInterface, fileName: string, fileType: string): void {
    this.onAdded.emit({base64File: base64File, fileName: fileName, fileType: fileType});
  }

  public deleteClick(): void {
    const confirm = this.alertCtrl.create({
      title: 'Confirmation',
      message: 'Voulez-vous supprimer cette pièce-jointe ?',
      buttons: [
        {
          text: 'Non',
          handler: () => {
          }
        },
        {
          text: 'Oui',
          handler: () => {
            this.fileName = null;

            this.onDeleted.emit(event);
          }
        }
      ]
    });
    confirm.present();
  }

  public emitClick(event): void {
    this.onClick.emit(event);
  }

  private presentActionSheet(): void {
    // Ask for file or photo
    // If done and not cancelled, do :
    const buttons = [];

    buttons.push({
      text: 'Choisir un fichier',
      role: 'destructive',
      handler: () => {
        this.openFilesystem();
      }
    });
    if (this.platform.is('ios')) {
      buttons.push({
        text: 'Galerie',
        role: 'destructive',
        handler: () => {
          this.openGallery(true);
        }
      });
    }
    buttons.push({
      text: 'Prendre une photo',
      role: 'destructive',
      handler: () => {
        this.openGallery(false);
      }
    });
    buttons.push({
      text: 'Annuler',
      role: 'cancel'
    });
    const actionSheet = this.actionSheetCtrl.create({
      title: 'Source du document',
      buttons: buttons
    });
    actionSheet.present();
  }

  openGallery(useGallery: boolean): void {
    const options: CameraOptions = {
      ...useGallery ? {sourceType: this.camera.PictureSourceType.SAVEDPHOTOALBUM} : {},
      destinationType: this.camera.DestinationType.FILE_URI,
      encodingType: this.camera.EncodingType.JPEG,
      mediaType: this.camera.MediaType.PICTURE,
      quality: 70,
      targetWidth: 1000,
      targetHeight: 1000,
      correctOrientation: true
    };
    this.camera.getPicture(options).then((imageData) => {
        this.readTakenPhoto(imageData);
      }, err => {
        console.log('cameraGetPictureError', err);
      });
  }

  openFilesystem(): void {
    this.chooser.getFile(null).then(file => {
        this.fileName = file.name;
        const base64File: Base64FileInterface = {nomFichier: file.name, mimetype: file.mediaType, content: file.dataURI as any};
        this.emitAdded(base64File, file.name, file.mediaType);
        this.appRef.tick();
    });
  }

  public readTakenPhoto(fileURI): void {
    this.file.resolveLocalFilesystemUrl(fileURI)
      .then((fileEntry: FileEntry) => {
        this.base64Parser.parse(fileEntry)
            .subscribe(parser =>  {
              if (this.checkExtension(parser.file.name)) {
                this.fileName = parser.file.name;
                return this.emitAdded(parser.base64File, this.fileName, parser.file.type);
              }
            });
      })
      .catch(error => console.log('error', error));
  }
  private checkExtension(fileName: string): boolean {
    const extension = fileName.substring(fileName.lastIndexOf('.') + 1).toLowerCase();
    if (this.extensionsAutorisees.indexOf(extension) > -1) {
      return true;
    } else {
      const alertMessage = this.alertCtrl.create({
        title: 'Erreur',
        message: 'Cette extension (' + extension + ') n\'est pas autorisée',
        buttons: ['Ok']
      });
      alertMessage.present();
      return false;
    }
  }
  public readURLInputFile(event: any): void {
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      this.fileName = file.name;
      this.base64Parser.parseFile(file)
          .subscribe(parser => this.emitAdded(parser.base64File, parser.file.name, parser.file.type));

    }
  }
}



// WEBPACK FOOTER //
// ./src/core/file-selector/file-selector.component.ts